import React from 'react';
import Xlsx from '../../../../../../assets/icons/Xlsx2';
import Home from '../../../../../../shared/components/Wrapper/Home';
import AnalyticReportCsv from '../SelectModal/analyticReportCsv';
import ReportMacroSmartExcel from '../SelectModal/ReportMacroSmart';

function index(props) {
  const { setToggle } = props;
  const [clickDownload, setClickDownload] = React.useState(false);
  const [AnalyticReportCsvShow, setAnalyticReportCsvShow] =
    React.useState(false);
  const [ReportMacroSmartExcelShow, setReportMacroSmartExcelShow] =
    React.useState(false);

  function setBankInfoModal(e: any) {
    if (e === 'ReportMacroSmartExcel') {
      setReportMacroSmartExcelShow(true);
    } else if (e === 'AnalyticReportCsv') {
      setAnalyticReportCsvShow(true);
    }
  }

  return (
    <>
      <Home.ContainerPrincipal>
        <Home.TitlePrincipal>Relatório de Tarifação</Home.TitlePrincipal>
      </Home.ContainerPrincipal>
      <Home.ContainerAction>
        <Home.Action>
          <Home.ActionDesc>Relatório Fechamento</Home.ActionDesc>
          <Home.ActionContent>
            <Home.ActionSelect>
              Relatório sintético
              <Home.ActionContainerButton>
                <Home.ActionSelectButton
                  onClick={() => {
                    setBankInfoModal('ReportMacroSmartExcel');
                    setClickDownload(false);
                  }}>
                  <Xlsx />
                </Home.ActionSelectButton>
              </Home.ActionContainerButton>
            </Home.ActionSelect>
            <Home.ActionSelect>
              Relatório analítico
              <Home.ActionContainerButton>
                <Home.ActionSelectButton
                  onClick={() => {
                    setBankInfoModal('AnalyticReportCsv');
                    setClickDownload(false);
                  }}>
                  <Xlsx />
                </Home.ActionSelectButton>
              </Home.ActionContainerButton>
            </Home.ActionSelect>
            <Home.BtnAction onClick={() => setToggle(2)}>
              Visualizar
            </Home.BtnAction>
          </Home.ActionContent>
        </Home.Action>
      </Home.ContainerAction>
      <ReportMacroSmartExcel
        show={ReportMacroSmartExcelShow}
        onHide={() => setReportMacroSmartExcelShow(false)}
        validation={setClickDownload}
        Clicked={clickDownload}
      />
      <AnalyticReportCsv
        show={AnalyticReportCsvShow}
        onHide={() => setAnalyticReportCsvShow(false)}
      />
    </>
  );
}

export default index;
